/**
 * @ngdoc directive
 * @name cbl.cartadebitoint.wa.directive:cdintDatiAggiuntiviPg
 * @restrict E
 * @description Componente per la visualizzazione di una pratica di credito
 *              assicurativo
 */
(function () {
  'use strict';
  var CdintDatiAggiuntiviPgCtrl = function (
    $q,
    $http,
    $scope,
    $state,
    $stateParams,
    $cacheFactory,
    CONSTANTS,
    labelSrvc,
    domainSrvc,
    messaggiFctr,
    propostaCartaDebitoIntSrvc,
    $uibModal
  ) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$cacheFactory = $cacheFactory;
    this.domainSrvc = domainSrvc;
    this.messaggiFctr = messaggiFctr;
    this.propostaCartaDebitoIntSrvc = propostaCartaDebitoIntSrvc;
    this.CONSTANTS = CONSTANTS;
    this.$uibModal = $uibModal;
    $scope.msg = labelSrvc.getLabel;

    /**
     * Indica se il caricamento delle labels è andato a buon fine
     */
    this.labelsPronte = false;

    /**
     * Riferimento allo spinner globale
     */
    this.spinner = this.propostaCartaDebitoIntSrvc.spinner;

    /**
     * ID Della pratica corrente
     */
    this.idPratica = null;

    /**
     * Dati anagrafici legati alla pratica
     */
    this.datiAnagrafici = null;

    /**
     * Elenco delle nazioni selezionabili
     */
    this.paesi = [];

    /**
     * Elenco delle provincie selezionabili
     */
    this.province = [];

    /**
     * Elenco dei comuni selezionabili
     */
    this.comuni = [];

    /**
     * Elenco dei cap selezionabili
     */
    this.cap = [];

    /**
     * Elenco delle località selezionabili
     */
    this.localita = [];

    /**
     * Flag che indica che l'anagrafica su cui si sta portando avanti la pratica
     * è incompleta quindi prima di poter proseguire bisogna aggiornarla.
     */
    this.anagraficaIncompleta = false;

    /**
     * Riferimento interno al controller per recuperare i valori nelle funzioni
     */
    var self = this;

    /**
     * Implementazione nel service della funzione di abilitazione salvataggio stato pratica
     */
    this.propostaCartaDebitoIntSrvc.salvaAbilitato = function () {
      return self.formValido();
    };

    /**
     * Implementazione nel service della funzione di abilitazione proseguimento iter pratica
     */
    this.propostaCartaDebitoIntSrvc.proseguiAbilitato = function () {
      return self.formValido();
    };

    /**
     * Implementazione nel service della funzione di visualizzazione bottone prosegui
     */
    this.propostaCartaDebitoIntSrvc.proseguiVisibile = function () {
      return true;
    };

    /**
     * Verifica se i dati inseriti nel form sono validi
     */
    this.formValido = function () {
      return (
        !!self.datiAnagrafici &&
        !!self.datiAnagrafici.indirizzoPrincipale &&
        !!self.datiAnagrafici.indirizzoPrincipale.via &&
        !!self.datiAnagrafici.indirizzoPrincipale.provincia &&
        !!self.datiAnagrafici.indirizzoPrincipale.comune &&
        !!self.datiAnagrafici.indirizzoPrincipale.cap &&
        !!self.datiAnagrafici.indirizzoPrincipale.nazione &&
        !!self.datiAnagrafici.indirizzoPrincipale.localita &&
        !self.anagraficaIncompleta
      );
    };

    /**
     * @ngdoc method
     * @name recuperaComuni
     * @methodOf cbl.cartadebitoint.wa:propostaCartaDebitoIntSrvc
     * @description Recupera i comuni per la spedizione.
     */
    this.recuperaComuni = function () {
      self.spinner.showSpinner++;
      var provincia = self.datiAnagrafici.indirizzoPrincipale.provincia;

      self.domainSrvc
        .promiseDomain('COMUNE', provincia)
        .then(function (domain) {
          self.comuni = domain;
        })
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     * @ngdoc method
     * @name recuperaCAP
     * @methodOf cbl.cartadebitoint.wa:propostaCartaDebitoIntSrvc
     * @description Recupera i CAP per la spedizione.
     */
    this.recuperaCAP = function () {
      self.spinner.showSpinner++;
      var comune = self.datiAnagrafici.indirizzoPrincipale.comune.codice;

      self.domainSrvc
        .promiseDomain('CAP', comune)
        .then(function (domain) {
          self.cap = domain;
        })
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     * @ngdoc method
     * @name recuperaLocalita
     * @methodOf cbl.cartadebitoint.wa:propostaCartaDebitoIntSrvc
     * @description Recupera le Localita per la spedizione.
     */
    this.recuperaLocalita = function () {
      self.spinner.showSpinner++;
      var cap = self.datiAnagrafici.indirizzoPrincipale.cap;
      var comune = self.datiAnagrafici.indirizzoPrincipale.citta;

      self.domainSrvc
        .promiseDomain('LOCALITA', cap, comune)
        .then(function (domain) {
          self.localita = domain;
          if (!self.localita.length) {
            self.localita.push({ codice: comune, descrizione: comune });
          }
        })
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     * @ngdoc method
     * @name recuperaDomini
     * @methodOf cbl.cartadebitoint.wa:propostaCartaDebitoIntSrvc
     * @description Recupera i domini per la spedizione.
     */
    this.recuperaDomini = function () {
      self.spinner.showSpinner++;

      $q.all([self.domainSrvc.promiseDomain('NAZIONE'), self.domainSrvc.promiseDomain('PROVINCIA')])
        .then(function (responses) {
          self.paesi = responses[0];
          self.province = responses[1];

          self.recuperaComuni();

          // Recupero anche i CAP se ho un CAP selezionato o un comune
          if (
            self.datiAnagrafici.indirizzoPrincipale &&
            (self.datiAnagrafici.indirizzoPrincipale.cap ||
              (self.datiAnagrafici.indirizzoPrincipale.comune && self.datiAnagrafici.indirizzoPrincipale.comune.codice))
          ) {
            self.recuperaCAP();
          }

          if (
            self.datiAnagrafici.indirizzoPrincipale &&
            (self.datiAnagrafici.indirizzoPrincipale.localita || self.datiAnagrafici.indirizzoPrincipale.cap)
          ) {
            self.recuperaLocalita();
          }
        })
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     * Esegue la chiamata per recuperare i dati anagrafici legati alla pratica
     */
    this.recuperaAnagrafica = function () {
      self.spinner.showSpinner++;

      self.propostaCartaDebitoIntSrvc
        .promiseRecuperaAnagrafica(self.idPratica)
        .then(function (response) {
          if (!response) {
            return;
          }

          // Processo prima la risposta perchè potrebbero esserci dei dati mancanti
          // relativi all'anagrafica e il servizio rende un messaggio per questo.
          self.anagraficaIncompleta = self.messaggiFctr.processaResponse(response);

          // Inizializzo i dati aggiuntivi a vuoti, per dare comunque un valore
          // e avviare la chiamata di salva/prosegui
          self.datiAnagrafici = response.data.result.anagrafica || {
            indirizzoPrincipale: {},
            contatti: {}
          };

          self.propostaCartaDebitoIntSrvc.datiAggiuntiviPg = {
            idPratica: self.idPratica
          };

          self.recuperaDomini();
        })
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     *  Funzione richiamata all'avvio del controller
     */
    this.init = function () {
      labelSrvc.labelsPronte.then(function () {
        self.labelsPronte = true;
        self.idPratica = self.propostaCartaDebitoIntSrvc.datiPratica.idPratica;

        self.recuperaAnagrafica();
      });
    };

    self.init();
  };

  CdintDatiAggiuntiviPgCtrl.$inject = [
    '$q',
    '$http',
    '$scope',
    '$state',
    '$stateParams',
    '$cacheFactory',
    'CDINT_CONSTANTS',
    'CdintLabelSrvc',
    'CdintDomainSrvc',
    'CdintMessaggiFctr',
    'CdintPropostaCartaDebitoIntSrvc',
    '$uibModal'
  ];

  var TemplateUrl = function (CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'cdintPropostaCartaDebitoInt/cdintDatiAggiuntiviPg/cdintDatiAggiuntiviPg.html'
    );
  };

  TemplateUrl.$inject = ['CDINT_CONSTANTS'];

  var CdintDatiAggiuntiviPgComponent = {
    controller: CdintDatiAggiuntiviPgCtrl,
    controllerAs: 'cdintDatiAggiuntiviPgCtrl',
    templateUrl: TemplateUrl
  };

  angular.module('cbl.cartadebitoint.wa').component('cdintDatiAggiuntiviPg', CdintDatiAggiuntiviPgComponent);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/cdintPropostaCartaDebitoInt/cdintDatiAggiuntiviPg/cdintDatiAggiuntiviPg.cmpt.js
// module id = 5
// module chunks = 0